import React from 'react'
import {
  resetLoginForm
} from 'src/actions/login'
import {
  updateMenuPanel
} from 'src/actions/frontend'

import RequireUserOnGuestList from 'containers/RequireUserOnGuestList'
import styles from '../menu.scss'

export class LoginPanel extends React.Component {
  render () {
    const onSubscribeSuccessActions = [updateMenuPanel('profile'), resetLoginForm()]

    return (
      <div className={styles['menu-panel']}>
        <h3 className={styles['menu-title']}>Login</h3>
        <RequireUserOnGuestList
          onSubscribeSuccessActions={onSubscribeSuccessActions}
          loginFormClassName={styles['menu-panel-content']}
          isMenu />
      </div>
    )
  }
}

export default LoginPanel



// WEBPACK FOOTER //
// ./src/components/menu/panels/LoginPanel.jsx